import { UserService } from '@/api/user';
import { AccessType } from '@/utils/constants/users';

export const useIsExternal = (): boolean => {
  const { data: user } = UserService.useGetProjectAssignees();

  return user?.user_type?.toUpperCase() === AccessType.EXTERNAL.toUpperCase();
};